import ccs from './ccs/manifest';
import { validateModules } from './nav';
import type { PortalModule } from './types';

export const modules: PortalModule[] = [ccs];

const problems = validateModules(modules);
if (problems.length > 0) {
  throw new Error(`模块注册表不合法：${problems.join('；')}`);
}

export function getModule(id: string): PortalModule | undefined {
  return modules.find((module) => module.id === id);
}